module.exports = __webpack_public_path__ + "img/SES_8755.cd5ac7c0.jpg";